import { Heading, Text } from '@everlywell/ui-kit';
import SectionContainer from 'components/PageSections/components/SectionContainer';
import React from 'react';

import FaqAccordion, { FaqItem } from './components/FaqAccordion';

export interface FaqV2Props {
  eyebrow: string;
  title: string;
  faqs: FaqItem[];
}

const FaqV2: React.FC<FaqV2Props | null> = (props) => {
  if (!props) {
    return null;
  }

  const { faqs, eyebrow, title } = props;

  return (
    <SectionContainer size={['sm', 'sm', 'md', 'lg']} centerContent>
      <Text
        marginBottom={['1', '2']}
        marginX="auto"
        size="lg"
        color="viridian.base"
        textAlign="center"
      >
        {eyebrow}
      </Text>
      <Heading
        marginX="auto"
        as="h2"
        // @ts-ignore
        size={['32px', '2xl']}
        marginBottom={[10, 16]}
        textAlign="center"
      >
        {title}
      </Heading>

      <FaqAccordion faqs={faqs} width={['100%', '100%', '100%', '1024px']} />
    </SectionContainer>
  );
};

export default FaqV2;
